import MetricBox from './MetricBox';

export type { MetricBoxProps } from './MetricBox';

export default MetricBox;
